import ajax from '../../../common/js/AjaxPromises';

interface SendOptions {
  headers?: Record<string, string>;
}

export class VideoTrackingService {
  send(
    url: string,
    data: Record<string, any>,
    options: SendOptions = {}
  ): Promise<any> {
    const queryParams = this.buildQueryParameters(data);
    const fullUrl = `${url}?${queryParams}`;
    if (!this.isFetchAvailable()) return this.sendAjax(fullUrl, options);

    return window.fetch(fullUrl, {
      keepalive: true
    });
  }

  sendAjax(url: string, options: SendOptions = {}): Promise<any> {
    return ajax.get(url, options);
  }

  isFetchAvailable(): boolean {
    return Boolean(window.fetch);
  }

  buildQueryParameters(params: Record<string, any>): string {
    return new URLSearchParams(params).toString();
  }
}
